(function () {
    'use strict';

    angular
        .module('franchisee.components')
        .controller('PeopleAssociateController', PeopleAssociateController)

    /** @ngInject */
    function PeopleAssociateController($timeout, HelperService, PersonService, AuthenticationService, UserService, sweetAlert, DEFAULT_IDENTIFIERS, SYSTEM_MODULES) {
        const vm = this;
        let loggedPersonAvailableUnits;

        // First step
        vm.searchPerson = () => {
            HelperService.startLoading('.loading-holder');

            PersonService
                .getByDocument(vm.searchPersonData.Document)
                .then(success => {
                    if (success)
                        initStepTwo(success);
                    else {
                        vm.hasUnitsToAssociate = handleAssociationToLoggedUserUnits();
                        vm.step = 3;
                        HelperService.stopLoading('.loading-holder');
                    }
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.loading-holder');
                })
        }

        // Second step
        vm.getFoundPersonImagePath = () => {
            if (vm.foundPerson.Person_Image.length) {
                return HelperService.imageHandlerPath('person', vm.foundPerson.Id, vm.foundPerson.Person_Image[0].Url);
            }

            return 'api/images/res/100/100/placeholder.jpg';
        }

        vm.associatePerson = isPreRegister => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Essa ação irá associar a pessoa com as permissões selecionadas!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    HelperService.startLoading('.loading-holder');

                    handlePersonAssociation(isPreRegister);
                }
            })
        }

        // Shared
        vm.resetPersonSearch = () => {
            vm.personUnitAssociationData = [];
            vm.errorCantEditSelf = false;
            vm.noUnitWithPermissions = false;
            vm.showStepOneData = true;
            vm.searchPersonData = {};
            vm.preRegisterPerson = null;
            vm.newUserData = {};
            vm.step = 1;
        }

        init();

        function initStepTwo(foundPerson) {
            const loggedUserId = AuthenticationService.getUserId();

            // Logged person can't edit his own relationships
            if (loggedUserId == foundPerson.Id) {
                vm.errorCantEditSelf = true;
                vm.showStepOneData = false;

                HelperService.stopLoading('.loading-holder');
            } else {
                vm.hasUnitsToAssociate = handleAssociationToLoggedUserUnits(foundPerson);

                vm.step = 2;

                HelperService.stopLoading('.loading-holder');
            }
        }

        function handleAssociationToLoggedUserUnits(foundPerson) {
            let hasUnitsToAssociate = false;

            // Check if person has any units to be associated or if he is already associated to all units owned by the logged user
            if (foundPerson && foundPerson.Person_Unit.length) {
                for (let index = 0; index < loggedPersonAvailableUnits.length; index++) {
                    const loggedPersonUnit = loggedPersonAvailableUnits[index];

                    if (foundPerson.Person_Unit.find(foundPersonUnit => (loggedPersonUnit.UnitId == foundPersonUnit.UnitId))) {
                        hasUnitsToAssociate = false;
                    } else {
                        hasUnitsToAssociate = true;
                    }
                }

            }
            // If the found person does not have any units related to him the logged user can associate any unit
            else {
                hasUnitsToAssociate = true;
            }

            // If the found person is not already associated with all units that the logged person has permission to handle people
            if (hasUnitsToAssociate) {
                vm.foundPerson = foundPerson;
                vm.loggedPersonAvailableUnits = loggedPersonAvailableUnits;
            }

            return hasUnitsToAssociate;
        }

        function handlePersonAssociation(isPreRegister) {
            let personUnitData = vm.personUnitAssociationData
                .filter((personAssociate) => (personAssociate.ResponsibilityId != null))
                .reduce((acc, cur) => {
                    let associationData;

                    if (isPreRegister) {
                        associationData = {
                            UnitId: cur.UnitId,
                            ResponsibilityId: cur.ResponsibilityId,
                            AccessLevelId: DEFAULT_IDENTIFIERS.ACCESS_LEVEL_FRANCHISEE_WORKER
                        }
                    } else {
                        associationData = {
                            UnitId: cur.UnitId,
                            PersonId: vm.foundPerson.Id,
                            ResponsibilityId: cur.ResponsibilityId,
                            AccessLevelId: DEFAULT_IDENTIFIERS.ACCESS_LEVEL_FRANCHISEE_WORKER
                        }
                    }

                    acc.push(associationData);

                    return acc;
                }, []);

            if (isPreRegister) {
                let preRegisterData = {
                    Name: vm.newUserData.Name,
                    Email: vm.newUserData.Email,
                    CreatorPersonId: vm.loggedUserData.PersonId,
                    PreRegister_Unit: personUnitData
                }

                UserService
                    .createPreRegister(preRegisterData)
                    .then(success => {
                        vm.step = 5;
                        vm.preRegisterPerson = success;

                        HelperService.stopLoading('.loading-holder');
                    }, error => {
                        // When the person already has a pre-register we don't let the user create a new one and inform him
                        if (error.status == 500) {
                            sweetAlert.swal({
                                title: 'Pessoa já possui pré-registro!',
                                text: 'Essa pessoa já possui um pré-registro em andamento, para realizar associação ela deve primeiro finalizar o cadastro.',
                                type: 'warning',
                                confirmButtonText: 'Ok',
                                showCancelButton: false,
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then(() => {
                                $timeout(() => {
                                    vm.resetPersonSearch();
                                })
                            })
                        } else {
                            HelperService.errorCallback(error);
                        }

                        HelperService.stopLoading('.loading-holder');
                    })
            } else {
                PersonService
                    .associateToUnit(personUnitData)
                    .then(() => {
                        vm.step = 4;

                        HelperService.stopLoading('.loading-holder');
                    }, error => {
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.loading-holder');
                    })
            }
        }

        function preInitValidation() {
            loggedPersonAvailableUnits = AuthenticationService.getUnitDataByAccessLevelAndModuleId(vm.loggedUserData.AccessLevelId, SYSTEM_MODULES.FRANCHISEE_PEOPLE);

            // Logged person does not have permission to handle person on any unit
            if (!loggedPersonAvailableUnits.length) {
                vm.noUnitWithPermissions = true;
                vm.showStepOneData = false;
                vm.showStepOneData = false;
            } else {
                vm.showStepOneData = true;
                vm.noUnitWithPermissions = false;
                vm.errorCantEditSelf = false;
            }
        }

        function init() {
            vm.loggedUserData = AuthenticationService.getSelectedData();
            vm.personUnitAssociationData = [];

            preInitValidation();

            vm.step = 1;
        }
    }
}());